export const resolveTz = (tz: string | null | undefined): string =>
  tz || Intl.DateTimeFormat().resolvedOptions().timeZone;

export const makeDateTimeFormatter = (
  tz: string,
  withSeconds = false,
): ((ts: number) => string) => {
  const formatter = new Intl.DateTimeFormat("es-ES", {
    timeZone: tz,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: withSeconds ? "2-digit" : undefined,
    hourCycle: "h23",
  });

  return (ts: number): string => {
    if (ts == null) return "N/A";
    const parts = formatter.formatToParts(new Date(ts));
    const get = (type: string): string =>
      parts.find((p) => p.type === type)?.value ?? "";
    const date = `${get("day")}/${get("month")}/${get("year")}`;
    const time = withSeconds
      ? `${get("hour")}:${get("minute")}:${get("second")}`
      : `${get("hour")}:${get("minute")}`;
    return `${date} ${time}`;
  };
};

export const toLocalInputValue = (date: Date): string => {
  const pad = (n: number): string => String(n).padStart(2, "0");
  const day = `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
  return `${day}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
